/**
 * Tracks which events a parent has already seen, so the Events tab on the
 * dashboard can blink / show "*" when a new event is added.
 *
 * Seen event ids are kept per student in localStorage. Visiting the Events
 * page marks every currently listed event as seen.
 */

const seenKey = (studentId) => `seen_event_ids_${studentId}`;

const readSeenIds = (studentId) => {
  try {
    const raw = localStorage.getItem(seenKey(studentId));
    const ids = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(ids) ? ids.map(String) : []);
  } catch {
    return new Set();
  }
};

export const markEventsSeen = (studentId, events) => {
  if (!studentId || !Array.isArray(events)) return;
  const seen = readSeenIds(studentId);
  events.forEach((e) => {
    if (e && e.id != null) seen.add(String(e.id));
  });
  try {
    localStorage.setItem(seenKey(studentId), JSON.stringify([...seen]));
  } catch {
    // Storage full / blocked - indicator just stays on, nothing else breaks.
  }
};

export const hasUnseenEvents = (studentId, events) => {
  if (!studentId || !Array.isArray(events) || events.length === 0) return false;
  const seen = readSeenIds(studentId);
  return events.some((e) => e && e.id != null && !seen.has(String(e.id)));
};
